import React from 'react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import Header from '../../component/common/Header';

import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import Loader from '../../component/common/Loader';
import TextEditor from '../../component/common/TextEditor';

import CONSTANT from '../../constant';
import { onChange, setOptions, validateForm, getCookie, getStorage, setStorage } from '../../utils';
import { addFile, uploadAttachment, checkFileNumber ,addEfile } from '../../actions/FileAction';
import { getApprovingAuthority } from '../../actions/UserAction';
import { getDepartmentList } from '../../actions/MasterAction';
import { getDraftList, deleteDraft ,autoSave} from '../../actions/eDraftAction';


class ComponentName extends React.Component<any, any>{

    // userProposal: any;
    // clrInterval: any;

    constructor(props: any) {
        super(props);
        const recipients = getStorage(CONSTANT.cookie.recipients);
        const todaysDate = new Date().toISOString().split('T')[0]
        const userDetail = getCookie(CONSTANT.cookie.userDetail);
        const proposal = getStorage('propsal');
        const proposalValue = proposal? proposal : "";
        this.state = {
            fileNumber: { name: 'fileNumber', value: `${userDetail.unitName}/${userDetail.departmentName}/`, error: '', isRequired: true },
            dated: { name: 'dated', value: todaysDate, error: '', isRequired: true },
            subject: { name: 'subject', value: '', error: '', isRequired: true },
            financialImplication: { name: 'financialImplication', value: '', error: '', isRequired: true },
            approvingAuthority: { name: 'approvingAuthority', value: '', error: '', isRequired: true, options: [] },
            body: { name: 'body', value: proposalValue, error: '', isRequired: true },
            to: { name: 'to', value: [] , options: recipients, error: '', isRequired: true },
            attachments: { name: 'attachments', value: [], error: '', isRequired: false },
            department: { name: 'department', value: [], error: '', isRequired: false, options: [] },
            showLoader: false,
            isFileNumberValid: undefined,
            userDetail
        }
    }

    componentDidMount() {
        
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.fileDetail;
        
        getDepartmentList().then((res: any) => {
            setOptions(this, this.state.department.name, res.result);
        });

        getApprovingAuthority().then((res: any) => {
            setOptions(this, this.state.approvingAuthority.name, res.result);
        });



    }

    render() {
        const { isFileNumberValid, fileNumber, dated, subject, body, to, attachments, department, financialImplication, approvingAuthority } = this.state;
        const { showLoader } = this.state;
        
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row my-3">
                            <div className="col-md-8">
                                <h1 className="page-title">File detail demo   </h1>
                            </div>
                            <div className="col-md-4">
                                <Link to={CONSTANT.component.userFileList.url} className="btn btn-sm btn-link float-right">Go Back</Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form onSubmit={this.onSubmit}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>File # <small>*</small></label>
                                                        <input
                                                            type="text"
                                                            className={ fileNumber.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            placeholder="File number"
                                                            name={fileNumber.name}
                                                            value={fileNumber.value}
                                                            onChange={this.onChange}
                                                            onBlur={this.onBlur}
                                                        />
                                                        {
                                                            isFileNumberValid === false && <small className="text-danger">A file with similar number already exists</small>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Dated <small>*</small></label>
                                                        <input
                                                            type="date"
                                                            className={dated.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            placeholder="Name of the employee"
                                                            name={dated.name}
                                                            value={dated.value}
                                                            onChange={this.onChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Subject <small>*</small></label>
                                                        <input
                                                            type="text"
                                                            className={subject.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            placeholder="Subject"
                                                            name={subject.name}
                                                            value={subject.value}
                                                            onChange={this.onChange}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Financial implication <small>*</small></label>
                                                        <NumberFormat
                                                            decimalScale={2}
                                                            thousandSeparator={true}
                                                            allowNegative={false}
                                                            className={financialImplication.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            placeholder="Must be greater than or equal to zero"
                                                            name={financialImplication.name}
                                                            value={financialImplication.value}
                                                            onValueChange={(e: any) => { this.onChange({ target: { name: financialImplication.name, value: e.value } }) }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Approving authority <small>*</small></label>
                                                       
                                                        <select
                                                            className={approvingAuthority.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            name={approvingAuthority.name}
                                                            value={approvingAuthority.value}
                                                            onChange={this.onChange}
                                                            >
                                                            <option>Select a Approver</option>
                                                            {
                                                                approvingAuthority.options.map(function (item: any, index: number) {
                                                                    return (
                                                                        <option key={index} value={item.code}>{item.name} - {item.employeeNumber}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>

                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Proposal <small>*</small></label>
                                                        <TextEditor
                                                            error={body.error}
                                                            name={body.name}
                                                            value={body.value}
                                                            onChange={this.onChange}
                                                            placeholder="Please elaborate the details of requirement, justification."
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Recipient <small>*</small></label>
                                                        <Typeahead
                                                            id="ta-recipient"
                                                            flip={true}
                                                            multiple={true}
                                                            labelKey={(option: any) => `${option.name} - ${option.employeeNumber}`}
                                                            name={to.name}
                                                            value={to.value}
                                                            options={to.options}
                                                            onChange={(e: any) => this.typeaheadOnChange(to.name, e)}
                                                            placeholder="Send to"
                                                            isInvalid={to.error.length > 0}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Department <sup>(optional)</sup></label>
                                                        <Typeahead

                                                            id="ta-department"
                                                            dropup={true}
                                                            labelKey="name"
                                                            name={department.name}
                                                            value={department.value}
                                                            multiple={true}
                                                            options={department.options}
                                                            onChange={(e: any) => this.typeaheadOnChange( department.name, e) }
                                                            placeholder="Specify the order of department in which the file should ideally move"
                                                            isInvalid={to.error.length > 0 }
                                                                    
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>File(s) <sup>(optional)</sup></label>
                                                        <input
                                                            name={attachments.name}
                                                            onChange={this.onChange}
                                                            type="file"
                                                            multiple={true}
                                                            className="form-control"
                                                            style={{ padding: 4 }}
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        {
                                                            Array.from(attachments.value).map(function (item: any, index: number) {
                                                                return (
                                                                    <span key={index} className="badge badge-primary mr-1">{item.name}</span>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <Link to={CONSTANT.component.userFileList.url} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</Link>
                                                </div>
                                                
                                                { /* <div className="col-md-6">
                                                <button type="submit" className="btn btn-block submit-button btn-sm" onClick={this.HandleDraft}>Save as Draft</button>
                                                </div> */ }

                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                
                {
                    showLoader && <Loader />
                }

            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        let value = e.target.value;
        if (name === this.state.attachments.name) {
            value = e.target.files;
        }
        if(name === this.state.body.name){
            setStorage("propsal", value);
        }
        onChange(this, name, value);
    }

    onBlur = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === this.state.fileNumber.name) {
            checkFileNumber(value).then((res: any) => {
                this.setState({
                    isFileNumberValid: !(res.result.length > 0)
                });
            })
        }
    }

    typeaheadOnChange = (name: string, e: any) => {
        let value = e;
        if (e.length > 0 && e[0].customOption) {
            value = [{ name: e[0].name }];
        }
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        
        e.preventDefault();
         
        if (validateForm(this) && this.state.isFileNumberValid && !this.state.showLoader) {
            this.setState({ showLoader: true });
            const st = this.state;
              
            const model = {
                fileNumber: st.fileNumber.value,
                dated: st.dated.value,
                subject: st.subject.value,
                body: st.body.value,
                to: st.to.value,
                financialImplication: st.financialImplication.value,
                approvingAuthority: [st.approvingAuthority.value],
                department: st.department.value
            };
            
            addEfile(model).then(async (res: any) => {
                
              
             
                if ( res.status === CONSTANT.static.apiStatus.success) {
                    alert("succesfully saved ")
                    this.setState({ showLoader: false });

                     
                    // for (let i = 0; i < st.attachments.value.length; i++) {
                        
                    //     const item = st.attachments.value[i];
                    //     const itemModel = { fileCode: res.result.code,  attachment: item  }
                    //     await uploadAttachment(itemModel)
                    
                    // }

                    // this.setState({ showLoader: false });
                    // setStorage("propsal", "");
                    // this.props.history.push(CONSTANT.component.userFileList.url);
                     
                } else {
                    this.setState({ showLoader: false });
                    alert(res.error);
                }
            });
        }
    }

    
    HandleDraft = (e: any) => {
        const isSure = window.confirm('Are you sure, you want to Save this?');
        if (isSure) {
            const id = parseInt(e.target.dataset.id, 10);
            autoSave(id).then((res: any) => {
                if (res.status === CONSTANT.static.apiStatus.success) {
                    window.location.reload();
                } else {
                    alert(res.error.message);
                }

            })
        }
    }

}





export default ComponentName;